<!-- История проверок и действие фиксации новой проверки ремонта. -->
<template>
  <BaseFormSection :title="collapsible ? 'Проверки' : 'Проверка'" icon="clipboardCheck" :count="collapsible ? inspections.length : null"
    :collapsible="collapsible" :initially-expanded="initiallyExpanded" :summary="inspectionSummary">
    <div v-if="showAction" class="inspection-toolbar">
      <base-primary-button
        type="button"
        class="inspection-add-button"
        @click="$emit('open-inspection')"
      >
        <AppIcon
          class="inspection-add-button__icon"
          name="edit"
          :size="16"
        />
        Зафиксировать
      </base-primary-button>
    </div>

    <div v-if="inspections.length" class="inspection-list">
      <div
        v-for="inspection in inspections"
        :key="inspection.id"
        class="inspection-entry"
      >
        <UserIdentityCard
          :user="inspection.inspector"
          :name="inspectionInspectorName(inspection)"
          :user-id="inspection.inspector_id"
          fallback-name="Система"
          fallback-initials="СИС"
          avatar-only
          class="inspection-entry__avatar"
        />

        <div class="inspection-entry__content">
          <div class="inspection-entry__text">
            <strong class="inspection-entry__actor">
              {{ inspectionInspectorName(inspection) }}
            </strong>
            <span class="inspection-entry__method">
              {{ inspectionMethodName(inspection) }}
            </span>
            <span class="inspection-entry__time">
              {{ formatInspectionDate(inspection.inspected_at) }}
            </span>
          </div>

          <p class="inspection-entry__comment">
            {{ inspection.comment || "Комментарий не указан" }}
          </p>
        </div>
      </div>
    </div>

    <div v-else class="inspection-empty">
      Проверок пока нет
    </div>
  </BaseFormSection>
</template>

<script>
import AppIcon from "@/components/Icon/AppIcon.vue";
import UserIdentityCard from "@/components/User/UserIdentityCard.vue";

import { formatDateAndTime } from "@/utils/dateUtils";

export default {
  name: "FleetRepairInspectionSection",

  components: {
    AppIcon,
    UserIdentityCard,
  },

  props: {
    showAction: { type: Boolean, default: true },
    collapsible: { type: Boolean, default: false },
    initiallyExpanded: { type: Boolean, default: true },
    repairData: {
      type: Object,
      default: null,
    },
  },

  emits: ["open-inspection"],

  computed: {
    inspectionSummary() {
      const inspection = this.inspections[0];
      return inspection
        ? `${this.inspectionMethodName(inspection)} · ${this.formatInspectionDate(inspection.inspected_at)}`
        : "Проверок пока нет";
    },
    inspections() {
      return this.repairData?.inspections || [];
    },
  },

  methods: {
    formatInspectionDate(value) {
      return formatDateAndTime(value);
    },

    inspectionInspectorName(inspection) {
      return this.userName(inspection.inspector);
    },

    inspectionMethodName(inspection) {
      return inspection.inspection_method_item?.name || "Способ не указан";
    },

    userName(user) {
      if (!user) return "—";

      const fullName = [
        user.last_name,
        user.first_name,
        user.middle_name,
      ]
        .filter(Boolean)
        .join(" ");

      return fullName || user.initials || user.email || "—";
    },
  },
};
</script>

<style scoped>
.inspection-toolbar,
.inspection-list,
.inspection-empty {
  grid-column: 1 / -1;
}

.inspection-toolbar {
  display: flex;
  align-items: center;
  justify-content: flex-start;
  gap: var(--base-in-indent);
  margin-bottom: var(--base-in-indent);
}

.inspection-add-button {
  display: inline-flex;
  align-items: center;
  gap: 8px;
}

.inspection-add-button__icon {
  flex: 0 0 auto;
  width: 16px;
  height: 16px;
}

.inspection-list {
  display: flex;
  flex-direction: column;
}

.inspection-entry {
  display: flex;
  gap: 10px;
  padding: 9px 0;
  border-bottom: 1px solid #f5f5f5;
}

.inspection-entry:last-child {
  border-bottom: none;
}

.inspection-entry__avatar {
  flex: 0 0 auto;
}

.inspection-entry__content {
  display: flex;
  min-width: 0;
  flex: 1;
  flex-direction: column;
  gap: 2px;
}

.inspection-entry__text {
  display: flex;
  align-items: baseline;
  flex-wrap: wrap;
  gap: 6px;
  line-height: 1.35;
}

.inspection-entry__actor {
  color: var(--color-dark);
  font-size: 13px;
}

.inspection-entry__method {
  display: inline-flex;
  align-items: center;
  padding: 0 7px;
  border-radius: 999px;
  background: #e7f7f4;
  color: #056b5c;
  font-size: 12px;
  font-weight: 600;
}

.inspection-entry__time,
.inspection-empty {
  color: #999;
  font-size: 12px;
}

.inspection-entry__comment {
  margin: 0;
  color: #4b5563;
  font-size: 13px;
  line-height: 1.4;
}

.inspection-empty {
  padding: 9px 0;
}
</style>
